import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { updateTime } from '../../utils/helper';
import { Chip } from '../Chip';
import styles from '@dtsl/css-timepicker/dist/index.module.css';
const ScrollablePanel = _ref => {
  let {
    range,
    interval,
    selectedValue,
    type,
    time,
    onChange
  } = _ref;
  let panelRef = useRef(null);
  useEffect(() => {
    const setScrollPosition = () => {
      if (panelRef?.current) {
        const selectedChip = panelRef?.current?.querySelector(`#chip-${selectedValue}`);
        if (selectedChip) {
          const chipOffsetTop = selectedChip.offsetTop;
          panelRef.current?.scrollTo({
            top: chipOffsetTop - 64,
            behavior: 'smooth'
          });
        }
      }
    };
    setScrollPosition();
  }, [selectedValue, panelRef]);
  const getElementValue = element => {
    return `${element >= 10 ? '' : '0'}${element}`;
  };
  const onChipClick = value => {
    if (selectedValue !== value) {
      const updatedTime = updateTime(time, selectedValue, value, type);
      onChange(updatedTime);
    }
  };
  const CreateChips = () => {
    const listItems = [];
    if (!Array.isArray(range)) {
      for (let element = 0; element < range; element += interval) {
        listItems.push(/*#__PURE__*/React.createElement(Chip, {
          value: getElementValue(element),
          key: getElementValue(element),
          dataTest: `chip-${getElementValue(element)}`,
          "data-testid": `chip-${getElementValue(element)}`,
          id: `chip-${getElementValue(element)}`,
          isSelected: element == selectedValue,
          onClick: onChipClick,
          tabIndex: 0
        }));
      }
      return listItems;
    }
    range.forEach(element => {
      listItems.push(/*#__PURE__*/React.createElement(Chip, {
        value: element,
        key: element,
        dataTest: `chip-${element}`,
        "data-testid": `chip-${element}`,
        id: `chip-${element}`,
        isSelected: element === selectedValue,
        onClick: onChipClick,
        tabIndex: 0
      }));
    });
    return listItems;
  };
  const scrollablePanelClass = classNames({
    [styles['sib-scrollable-panel']]: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: scrollablePanelClass,
    ref: panelRef,
    id: `scrollable_panel_${type}`
  }, /*#__PURE__*/React.createElement(CreateChips, null));
};
ScrollablePanel.defaultProps = {
  interval: 1
};
ScrollablePanel.propTypes = {
  range: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  interval: PropTypes.number,
  type: PropTypes.string.isRequired,
  selectedValue: PropTypes.number,
  time: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};
export default ScrollablePanel;